import { render, staticRenderFns } from "./public-cases-query.vue?vue&type=template&id=604963bd"
import script from "./public-cases-query.vue?vue&type=script&lang=ts"
export * from "./public-cases-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports